import(/* webpackMode: "eager" */ "/codebuild/output/src4070175448/src/apps/fanychance/src/components/layouts/PageHeader/PageHeader.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src4070175448/src/apps/fanychance/src/features/faq/components/FaqSearchForm/FaqSearchForm.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4070175448/src/apps/fanychance/src/features/faq/components/FaqTagList/FaqTagList.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4070175448/src/apps/fanychance/src/features/faq/components/FaqList/FaqList.module.scss");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src4070175448/src/node_modules/next/dist/client/link.js");
